import Reducer from './../util/reducer'
import {
  GET_INTENT_STAGE,
  GET_INTENT_INVITE,
  DO_VOUCHER_STAGE,
  DO_VOUCHER_INVITE
} from './../actions/payment'

const reducer = new Reducer()

reducer.register(GET_INTENT_STAGE + '/SUCCESS', (info) => {
  return {
    intents: {
      [info.stage]: {
        clientSecret: info.result.client_secret,
        intentId: info.result.intentId,
        type: 'claimStage',
        success: true
      }
    }
  }
})

reducer.register(GET_INTENT_STAGE + '/FAILED', (info) => {
  return {
    intents: {
      [info.stage]: {
        clientSecret: null,
        intentId: null,
        type: 'claimStage',
        success: false
      }
    }
  }
})

reducer.register(GET_INTENT_INVITE + '/SUCCESS', (info) => {
  return {
    intents: {
      [info.inviteId]: {
        clientSecret: info.result.client_secret,
        intentId: info.result.intentId,
        type: 'acceptInvite',
        success: true
      }
    }
  }
})

reducer.register(GET_INTENT_INVITE + '/FAILED', (info) => {
  return {
    intents: {
      [info.inviteId]: {
        type: 'acceptInvite',
        success: false
      }
    }
  }
})

reducer.register(DO_VOUCHER_STAGE + '/SUCCESS', (info) => {
  return {
    vouchers: {
      [info.stage]: {
        type: 'claimStage',
        success: true,
        voucher: info.voucher
      }
    }
  }
})

reducer.register(DO_VOUCHER_STAGE + '/FAILED', (info) => {
  return {
    vouchers: {
      [info.stage]: {
        type: 'claimStage',
        success: false,
        voucher: info.voucher
      }
    }
  }
})

reducer.register(DO_VOUCHER_INVITE + '/SUCCESS', (info) => {
  return {
    vouchers: {
      [info.inviteId]: {
        type: 'acceptInvite',
        success: true,
        voucher: info.voucher
      }
    }
  }
})

reducer.register(DO_VOUCHER_INVITE + '/FAILED', (info) => {
  return {
    vouchers: {
      [info.inviteId]: {
        type: 'acceptInvite',
        success: false,
        voucher: info.voucher
      }
    }
  }
})

export default reducer.build()